import { useColorScheme } from '@libs/core';

/** Effective light/dark scheme. Resolved and applied to `<html data-theme>` by `CoreProvider` from `@libs/core`. */
export const useResolvedTheme = useColorScheme;
